import React, { useState, useEffect, useMemo, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { apiGetEventContent, apiPutEventContent } from "api/api";

import {
  Card,
  Form,
  Input,
  Button,
  Modal,
  Upload,
  Image,
  notification,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";

import axios from "axios";

const Activity = () => {
  const quillRef = useRef();
  const [api, contextHolder] = notification.useNotification();
  const [initialData, setInitialData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const requireMsg = "此欄位必填!";
  const id = sessionStorage.target_id;

  // # 獲取資料
  const fetchData = async () => {
    try {
      const res = await apiGetEventContent({ id });
      console.log("rrrrres:", res);
      const { content } = res.data;
      setInitialData(content.content);
    } catch (err) {
      console.log("錯誤", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // * 提交表單
  const onFinish = (values) => {
    handleUpdate(values);
  };

  const handleUpdate = async (values) => {
    const { summary, notification, introduction } = values;
    setIsBtnLoading(true);
    try {
      const res = await apiPutEventContent({
        id,
        summary,
        notification,
        introduction,
      });
      message.success("更新成功");
    } catch (err) {
      console.log("err", err);
    } finally {
      setIsBtnLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // # 點擊圖片 icon
  const imageHandler = (e) => {
    const editor = quillRef.current.getEditor();
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (/^image\//.test(file.type)) {
        console.log(file);
        const formData = new FormData();
        formData.append("sourceId", id);
        formData.append("source", "Activity");
        formData.append("file", file);
        formData.append("platform", "web");
        formData.append("position", "content");
        formData.append("type", 2);
        api.info({
          message: `檔案上傳中`,
          description: "請稍候..",
        });
        const res = await onFileUpload(formData); // upload data into server or aws or cloudinary
        const url = res?.data?.content;
        editor.insertEmbed(editor.getSelection().index, "image", url);
      } else {
        console.log("You could only upload images.");
      }
    };
  };

  // # 圖片上傳
  const onFileUpload = async (formData) => {
    const token = sessionStorage.t;
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/attachment`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      api.success({
        message: `上傳成功`,
        description: `${res.data.message}`,
      });
      return res;
    } catch (err) {
      api.error({
        message: `上傳失敗`,
        description: "",
      });
      setTimeout(() => {
        fetchData();
      }, 500);

      console.log("失敗：：", err);
    }
  };

  // * 編輯器
  const handleRichText = (value) => {
    console.log("value", value);
  };

  // # 編輯器 toolbar config
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ font: [] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          [{ script: "sub" }, { script: "super" }],
          ["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }],

          [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
          [{ direction: "rtl" }],
          [{ size: ["small", false, "large", "huge"] }],
          ["link", "image", "video"],
          ["clean"],
        ],
        handlers: {
          image: imageHandler,
        },
        history: {
          delay: 500,
          maxStack: 100,
          userOnly: true,
        },
      },
      resize: {
        locale: {},
      },
    }),
    [],
  );

  // # 注意事項編輯器 toolbar config
  const notifyModules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ font: [] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          [{ script: "sub" }, { script: "super" }],
          ["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }],

          [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
          [{ direction: "rtl" }],
          [{ size: ["small", false, "large", "huge"] }],
          ["link"],
          ["clean"],
        ],
        history: {
          delay: 500,
          maxStack: 100,
          userOnly: true,
        },
      },
    }),
    [],
  );

  // const formats = ["image"];

  return (
    <div className="w-full">
      {contextHolder}
      <h2 className="text-Gray-8 mb-0">活動內容</h2>
      <p className="m-0 text-Gray-5">
        詳細介紹你的活動內容，讓消費者了解活動且提高參加意願！
      </p>
      <Card className="text-center mt-5 rounded-3xl px-10 sm:px-0" loading={isLoading}>
        <Form
          name="activity"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
          variant="filled"
          size="large"
          initialValues={initialData}
        >
          <Form.Item
            label="活動摘要"
            name="summary"
            className="[&_label]:font-semibold [&_label]:text-xl"
            rules={[
              {
                required: true,
                message: requireMsg,
              },
            ]}
          >
            <Input.TextArea
              autoSize={{ minRows: 5 }}
              placeholder="請充分描繪活動亮點，包括「活動關鍵詞」。以提高 Google 搜尋的曝光成效。"
              showCount
              maxLength={250}
            ></Input.TextArea>
          </Form.Item>
          <Form.Item
            label="活動簡介"
            name="introduction"
            className="[&_label]:font-semibold [&_label]:text-xl [&_.ant-form-item-control-input-content]:h-[900px]"
            rules={[
              {
                required: true,
                message: requireMsg,
              },
            ]}
          >
            <ReactQuill
              theme="snow"
              modules={modules}
              // formats={formats}
              onChange={handleRichText}
              placeholder=""
              ref={quillRef}
              className="h-full [&::placeholder]:text-red-400 [&_.ql-toolbar]:border-none [&_.ql-toolbar]:bg-Deep-Blue [&_.ql-toolbar]:text-white [&_.ql-container]:min-h-60 [&_.ql-container]:rounded-bl-xl [&_.ql-container]:rounded-br-xl [&_.ql-container]:rounded-bl-xl [&_.ql-toolbar]:rounded-tl-xl [&_.ql-toolbar]:rounded-tr-xl [&_.ql-editor]:text-base [&_.ql-editor]:text-white [&_.ql-container]:border-none [&_.ql-container]:bg-black [&_.ql-stroke]:stroke-white [&_.ql-fill]:fill-white [&_.ql-picker-label]:text-white"
            />
          </Form.Item>
          <Form.Item
            label="注意事項"
            name="notification"
            className="[&_label]:font-semibold [&_label]:text-xl mt-20"
          >
            {/* <Input.TextArea
              autoSize={{ minRows: 5 }}
              placeholder="請填寫注意事項"
              showCount
              maxLength={2000}
            ></Input.TextArea> */}
            <ReactQuill
              theme="snow"
              modules={notifyModules}
              // formats={formats}
              onChange={handleRichText}
              placeholder="請填入內容"
              // ref={quillRef}
              className="[&::placeholder]:text-red-400 [&_.ql-toolbar]:border-none [&_.ql-toolbar]:bg-Deep-Blue [&_.ql-toolbar]:text-white [&_.ql-container]:min-h-60 [&_.ql-container]:rounded-bl-xl [&_.ql-container]:rounded-br-xl [&_.ql-container]:rounded-bl-xl [&_.ql-toolbar]:rounded-tl-xl [&_.ql-toolbar]:rounded-tr-xl [&_.ql-editor]:text-base [&_.ql-editor]:text-white [&_.ql-container]:border-none [&_.ql-container]:bg-black [&_.ql-stroke]:stroke-white [&_.ql-fill]:fill-white [&_.ql-picker-label]:text-white"
            />
          </Form.Item>
          <Form.Item>
            <Button
              htmlType="submit"
              type="primary"
              className="w-full"
              loading={isBtnLoading}
            >
              儲存
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Activity;
